// Every lead flow block owns one query parameter for its current step. The
// prefix is reserved for that purpose: the session key drops any parameter
// that carries it, so it never needs to know which blocks are on the page.
// It is specific enough that campaign parameters never share it.
const STEP_PARAMETER_PREFIX = "lead-flow-step-";

function getStepParameterName(blockKey: string): string {
  return `${STEP_PARAMETER_PREFIX}${blockKey}`;
}

function isStepParameterName(parameterName: string): boolean {
  return parameterName.startsWith(STEP_PARAMETER_PREFIX);
}

export { getStepParameterName, isStepParameterName };
